import React, { useState } from "react";
import { SectionHeading } from "components/misc/Headings";
import tw from "twin.macro";
import Layout from "components/layouts/Layout";
import GlobalStyles from "styles/GlobalStyles";
import WordSpacedText from "../components/WordSpacedText";

// Use process.env.PUBLIC_URL consistently for all public folder assets
const LOGO_SRC = process.env.PUBLIC_URL + "/logo512.png";
const SCANNER_IMAGE = process.env.PUBLIC_URL + "/Jma_Scanner.jpg";
const QR_CODE_SRC =
  "https://api.qrserver.com/v1/create-qr-code/?data=digitaljamia@upi&size=200x200";

const UPI_ID = "digitaljamia@upi";

const BANK_DETAILS = {
  accountNumber: "11712109271",
  accountName: "JMA COLLEGE COMMITTEE",
  ifsc: "SBIN0000960",
  bankName: "State Bank of India",
  branch: "Rayadurg",
};

function copyToClipboard(text) {
  navigator.clipboard.writeText(text);
  alert("Copied: " + text);
}

function downloadBankDetails() {
  const details = `
Account Name: ${BANK_DETAILS.accountName}
Account Number: ${BANK_DETAILS.accountNumber}
IFSC Code: ${BANK_DETAILS.ifsc}
Bank Name: ${BANK_DETAILS.bankName}
Branch: ${BANK_DETAILS.branch}
`;
  const blob = new Blob([details], { type: "text/plain" });
  const link = document.createElement("a");
  link.href = URL.createObjectURL(blob);
  link.download = "bank_details.txt";
  link.click();
}

function saveQRCode() {
  const link = document.createElement("a");
  link.href = QR_CODE_SRC;
  link.download = "upi_qr_code.png";
  link.click();
}

function downloadScannerImage() {
  const link = document.createElement("a");
  link.href = SCANNER_IMAGE;
  link.download = "Jma_Scanner.jpg";
  link.click();
}

const Heading = tw(SectionHeading)`text-center text-gray-900 mb-6`;

const wordSpacingStyle = { wordSpacing: "0.4em" };

export default function DonationPage() {
  const [tab, setTab] = useState("upi");

  return (
    <>
      <GlobalStyles />
      <Layout>
        <div
          style={{
            maxWidth: 600,
            margin: "40px auto",
            fontFamily: "CustomFont",
            background: "#f9f9f9",
            borderRadius: 16,
            boxShadow: "0 8px 24px rgba(0,0,0,0.08)",
            padding: 32,
            textAlign: "center",
          }}
        >
          <Heading>Donations</Heading>

          {/* Display logo image */}
          <img
            src={LOGO_SRC}
            alt="Jamia Logo"
            style={{
              width: 120,
              height: 120,
              borderRadius: "50%",
              objectFit: "cover",
              margin: "0 auto 16px",
              display: "block",
            }}
          />

          {/* Display scanner image */}
          {/* <img
            src={SCANNER_IMAGE}
            alt="Scanner"
            style={{
              width: 200,
              height: "auto",
              borderRadius: 12,
              marginBottom: 20,
              display: "block",
              border: "1px solid #ddd",
              marginLeft: "auto",
              marginRight: "auto",
            }}
          /> */}

          <h2
            style={{ color: "#1976d2", marginBottom: 12, ...wordSpacingStyle }}
          >
            Support to Jamia Mohammadia Arabia Rayadurg
          </h2>

          <p style={{ fontSize: 15, color: "#444", ...wordSpacingStyle }}>
            Your support helps us preserve and digitize valuable resources.
          </p>

          <div
            style={{
              display: "flex",
              margin: "24px 0",
              background: "#e3f2fd",
              borderRadius: 8,
              overflow: "hidden",
            }}
          >
            <button
              onClick={() => setTab("upi")}
              style={{
                flex: 1,
                padding: 12,
                background: tab === "upi" ? "#1976d2" : "transparent",
                color: tab === "upi" ? "#fff" : "#1976d2",
                border: "none",
                fontWeight: "bold",
                fontSize: 15,
                cursor: "pointer",
              }}
            >
              <WordSpacedText>UPI Payment</WordSpacedText>
            </button>
            <button
              onClick={() => setTab("bank")}
              style={{
                flex: 1,
                padding: 12,
                background: tab === "bank" ? "#1976d2" : "transparent",
                color: tab === "bank" ? "#fff" : "#1976d2",
                border: "none",
                fontWeight: "bold",
                fontSize: 15,
                cursor: "pointer",
              }}
            >
              <WordSpacedText>Bank Transfer</WordSpacedText>
            </button>
          </div>

          {tab === "upi" && (
            <div
              style={{
                background: "#fff",
                borderRadius: 12,
                padding: 24,
                textAlign: "center",
                boxShadow: "0 2px 8px rgba(0,0,0,0.06)",
              }}
            >
              <p style={{ fontSize: 16, marginBottom: 8 }}>
                <strong>UPI ID:</strong> {UPI_ID}
                <button
                  onClick={() => copyToClipboard(UPI_ID)}
                  style={{
                    marginLeft: 10,
                    padding: "3px 10px",
                    fontSize: 13,
                    border: "1px solid #1976d2",
                    background: "#fff",
                    color: "#1976d2",
                    borderRadius: 6,
                    cursor: "pointer",
                  }}
                >
                  Copy
                </button>
              </p>

              {/* <img
                src={QR_CODE_SRC}
                alt="UPI QR Code"
                style={{
                  width: 200,
                  height: 200,
                  borderRadius: 12,
                  margin: "16px auto",
                  border: "1px solid #ddd",
                }}
              /> */}

              <img
                src={SCANNER_IMAGE}
                alt="Scanner"
                style={{
                  width: 200,
                  height: "auto",
                  borderRadius: 12,
                  marginBottom: 20,
                  display: "block",
                  border: "1px solid #ddd",
                  marginLeft: "auto",
                  marginRight: "auto",
                }}
              />

              <button
                onClick={downloadScannerImage}
                style={{
                  padding: "10px 24px",
                  background: "#1976d2",
                  color: "#fff",
                  border: "none",
                  borderRadius: 8,
                  fontWeight: "bold",
                  fontSize: 15,
                  cursor: "pointer",
                  marginTop: 10,
                }}
              >
                <WordSpacedText>Download QR Details Image</WordSpacedText>
              </button>
            </div>
          )}

          {tab === "bank" && (
            <div
              style={{
                background: "#fff",
                borderRadius: 12,
                padding: 24,
                boxShadow: "0 2px 8px rgba(0,0,0,0.06)",
              }}
            >
              {Object.entries(BANK_DETAILS).map(([label, value]) => (
                <div
                  key={label}
                  style={{
                    marginBottom: 14,
                    display: "flex",
                    alignItems: "center",
                  }}
                >
                  <strong
                    style={{
                      minWidth: 130,
                      fontSize: 15,
                      textTransform: "capitalize",
                    }}
                  >
                    {label.replace(/([A-Z])/g, " $1") + ":"}
                  </strong>
                  <span
                    style={{
                      flex: 1,
                      fontSize: 15,
                      textTransform: "uppercase",
                    }}
                  >
                    {value}
                  </span>
                  <button
                    onClick={() => copyToClipboard(value)}
                    style={{
                      marginLeft: 10,
                      fontSize: 13,
                      padding: "2px 10px",
                      border: "1px solid #1976d2",
                      background: "#fff",
                      color: "#1976d2",
                      borderRadius: 6,
                      cursor: "pointer",
                    }}
                    aria-label={`Copy ${label}`}
                  >
                    Copy
                  </button>
                </div>
              ))}

              <div style={{ textAlign: "center", marginTop: 24 }}>
                <button
                  onClick={downloadBankDetails}
                  style={{
                    padding: "10px 28px",
                    background: "#1976d2",
                    color: "#fff",
                    border: "none",
                    borderRadius: 8,
                    fontWeight: "bold",
                    fontSize: 15,
                    cursor: "pointer",
                  }}
                >
                  Download Bank Details
                </button>
              </div>
            </div>
          )}
        </div>
      </Layout>
    </>
  );
}
